import React, { useState } from 'react';

const EventsContext = React.createContext([{}, () => {}]);

const EventsProvider = (props) => {
    const [eventsState, setEventsState] = useState({
        theEvents: [
            {
                Enabled: false,
                Image: "Loading...",
                ImagePublicId: "Loading...",
                Title: "Loading...",
                SubTitle: "Loading...",
                Description: "Loading...",
                Type: "Loading...",
                Contact: "Loading...",
                Phone: "Loading...",
                Email: "Loading...",
                OtherWebsite: "Loading...",
                Location: "Loading...",
                StartDate: "Loading...",
                EndDate: "Loading...",
                AgeRestriction: "Loading...",
                GenderRestriction: "Loading...",
                YoungerThan: "Loading...",
                RequireWaivers: false,
                RequireNameEmail: false,
                RequireDOB: false,
                RequireGender: false,
                RequirePhone: false,
                IncludeQuestions: false,
                Registrations: [],
                IncludedQuestions: [],
                AcceptOnlineRegistration: false,
                Price: 0,
                AfterSubmit: "Loading...",
            }
        ],
        theEvent:
            {
                Enabled: false,
                Image: "",
                ImagePublicId: "",
                Title: "",
                SubTitle: "",
                Description: "",
                Type: "",
                Contact: "",
                Phone: "",
                Email: "",
                OtherWebsite: "",
                Location: "",
                StartDate: "",
                EndDate: "",
                AgeRestriction: "",
                GenderRestriction: "",
                YoungerThan: "",
                RequireWaivers: false,
                RequireNameEmail: false,
                RequireDOB: false,
                RequireGender: false,
                RequirePhone: false,
                IncludeQuestions: false,
                Registrations: [],
                IncludedQuestions: [],
                AcceptOnlineRegistration: false,
                Price: 0,
                AfterSubmit: "",
                imageChanged: false
            },
    });
    return (
        <EventsContext.Provider value={[eventsState, setEventsState]}>
            {props.children}
        </EventsContext.Provider>
    );
};

export { EventsContext, EventsProvider };
